var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteCage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3.12109H13.4655",
    stroke: "#FA4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76746 2.90517V0.75H10.4485V2.90517",
    stroke: "#FA4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25879 3.12109L2.68982 13.2504H11.526L12.1726 3.12109",
    stroke: "#FA4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCage);
export default __webpack_public_path__ + "static/media/delete-cage.b2240b098f2de4aa68272a74f71402b6.svg";
export { ForwardRef as ReactComponent };